export default {
  toast: {
    "form_validation.error_add_dataset": "Form validation failed. Please check the form for errors.",
    "form_validation.error_edit_dataset": "Form validation failed. Please check the form for errors.",
    "error_no_query_selections": "Dataset must have at least one column or aggregation selected to be published.",
    fetch_failed: "Failed to fetch data",
    fetch_failed_code: "Failed to fetch data with code: {{code}}",
    error: "Error",
    success: "Success",
    warning: "Warning",
    info: "Info",
    failed: "Failed",
    insufficient_permissions: "Insufficient permissions",
    success__add_group: "Group added",
    success_add_user: "User added",
    success_add_service_account: "Service account added",
    success_edit_user: "User updated",
    success_edit_group: "Group updated",
    error_add_user: "Failed to create user",
    success_edit_service_account: "Service account updated",
    success_edit_dataset: "Dataset updated",
    success_add_dataset: "Dataset created",
    success_publish_dataset: "Dataset published",
    success_deactivate_dataset: "Dataset deactivated",
    success_reDraft_dataset: "Dataset unpublished",
    success_delete_dataset: "Dataset deleted",
    error_delete_dataset: "Failed to delete dataset",
    error_publish_dataset: "Failed to publish dataset",
    error_deactivate_dataset: "Failed to deactivate dataset",
    error_reDraft_dataset: "Failed to unpublish dataset",
    error_add_dataset: "Failed to create dataset",
    error_edit_dataset: "Failed to update dataset",

    error_edit_user: "Failed to update user",
    error_add_group: "Failed to create group",
    error_edit_group: "Failed to update group",
    success_delete_group: "Group deleted",
    error_delete_group: "Failed to delete group",
    error_add_service_account: "Failed to create service account",
    error_edit_service_account: "Failed to update service account",
    success_resend_activation_user: "Activation email resent",
    error_resend_activation_user: "Failed to resend activation email",
    success_delete_user: "User deleted",
    error_delete_user: "Failed to delete user",
  },
  user: {
    management: "User management",
    name: "Name",
    add: "Add user",
    manage: "User management",
    username: "User name",
    firstName: "First name",
    lastName: "Last name",
    last_name: "Last name",
    email: "Email",
    enabled: "Enabled",
    emailVerified: "Email verified",
    resend_activation: "Resend activation email",
    resend_confirm_title: "Confirm that you want to resend the activation email.",
    resend_confirm: "Are you sure you want to resend the activation email to this user?",
    delete_confirm_title: "Confirm that you want to delete this user.",
    delete_confirm: "Are you sure you want to delete this user?"
  },
  breadcrumbs: {
    users: "Users",
    dashboards: "Dashboards",
    groups: "Groups",
    dataset: "Dataset",
    audit_log: "Audit Log",
  },
  service_account: {
    service_account: "Service account",
    service_accounts: "Service accounts",
    name: "Name",
    group: {
      name: "Group name",
      group_identifier: "Group id",
    },
    is_active: "Enabled",
    isActive: "Enabled",
    save: "Save",
    cancel: "Cancel"
  },
  dataset: {
    name: "Name",
    description: "Description",
    status: "Status",
    child_dataset: "Child dataset",
    version: "Version",
    public: "Public",
    active: "Active",
    created_at: "Created on",
    last_modified_at: "Last modified on",
    create: "Create dataset",
    modified_by: "Modified by",
    fields: "Fields",
    aggregation: "Aggregation",
    group_by: "Group by",
    publish: "Publish",
    deactivate: "Deactivate",
    activate: "Activate",
    Activate: "Activate",
    filters: "Dataset - Filters",
    status_code: {
      draft: "Draft",
      published: "Published"
    },
    filter: {
      name: "Filter",
      static: "Static",
      dynamic: "Dynamic",
      static_title: "Static Filters",
      dynamic_title: "Dynamic Filters",
      keywords: "Keywords",
      keyword: {
        YESTERDAY: "Yesterday",
        LAST_WEEK: "Last week",
        LAST_MONTH: "Last month",
      },
      labels: {
        groups: "Dataset contains one of Groups"
      }
    },
    tableAndColumnDescriptions: "Table selection and column descriptions",
    group_by_redundancies: "\"group by\" is made on fields not included in selected columns.",
  },

  permissions: {
    admin: "Admin",
    dataset: "Dataset",
    audit: "Audit Log",
    dataLake: "Data Lake",
    groups: "Groups",
    users: "Users",
    create: "Create",
    publish: "Publish",
    delete: "Delete",
    read: "Read",
    access: "Access",
    API: "API",
  },
  group: {
    group: "Group",
    name: "Name",
    description: "Description",
    permissions: "Permissions",
    admin: "Admin",
    dataset: "Dataset",
    audit: "Audit",
    dataLake: "Data Lake",
    groups: "Groups",
    users: "Users",
    create: "Create group",
    number_of_users: "Number of users in group",
    manage: {
      permissions: "Manage Permissions",
    }
  },
  label: {
    groups: {
      filter: "Add Filter Groups",
    },
    dataset: {
      add_groups: "Add Group Membership"
    },
    user: {
      add_groups: "Add Group Membership"
    },

  },
  data: {
    table_name: "Table name",
    label: "Label",
    column: "Column",
    operation: "Operation",
    group_by: "Group by",
    value: "Value",
    start: "Start",
    end: "End",
    filterValueMode: "Overridable",
    valueSource: "Value",
    keyword: "Keyword",
  },

  audit: {
    user: "User",
    dataset_name: "Dataset name",
    is_public_dataset: "Public dataset",
    ip_address: "IP Address",
    accessed_at: "Accessed at"
  },

  drawer: {
    groups: "Groups",
    users: "Users",
    dashboard: "Dashboard",
    audit: "Audit",
    audit_log: "Audit Log",
    data: "Data",
    dataset: "Dataset",
  },
  dashboards: {
    mode: {
      processed: "Processed data",
      raw: "Raw data",
    },
    filter: "Filter",
    site_location_select: "Select site location",
    menuLabel: "Dashboards",
    dashboards: "Dashboards",
    traffic_load: "Traffic Load",
    time_period: "Time Period",
    filter_date_from: "From",
    filter_date_to: "To",
    axles_overload: {
      histogram: "Axles Overload Histogram",
    },
    vehicle_hourly_average: {
      hourly_average_statistics_all_vehicles: "Average number of vehicles per hour of the day",
    },
    overload_speed: {
      graph: "Overload Speed Graph",
      overload_vehicles_per_speed_percentage: "Overload vehicles per speed percentage",
      speed_category: "Value",
    },
    daily_average_vehicles: {
      title: "Average number of vehicles per day "
    },
    overload_rates: {
      title: "Overload Rates",
    },
    measurements_total: {
      title: "Measurements total",
    },
    overload_rates_direction: {
      title: "Overloading rates by direction",
    },
    overload_by: {
      site: "Site",
      direction: "Direction",
      site_direction: "Site - Direction",
    },
    totals_by: {
      site: "Total number of vehicles per site",
      direction: "Direction",
      site_direction: "Site - Direction",
    },
    tabs: {
      PKI1: "Loading and overloading 1",
      PKI2: "Loading and overloading 2",
      PKI3: "Location map",
      PKI3_content: {
        filter: "Filter",
        fit_bounds: "Fit Bounds",
      }
    },
    pki: {
      filter: {
        included: "Included",
        excluded: "Excluded",
      }
    }

  },
  "dashboards_view": {
    "filters": {
      "filter_sites": "Filter measurement sites",
      "filter_directions": "Filter measurement directions",
    },
    "sort_by": "Sort by",
    "sort_direction": "Sort direction",
    "asc": "Ascending",
    "desc": "Descending",
    "mode": "Grouping Mode",
    "filter": "Filter",
    "site_location_select": "Select site location",
    "menuLabel": "Dashboards",
    "dashboards": "Dashboards",
    "traffic_load_trend": "Traffic load trend",
    "load_and_overload": "Overloading Statistic",
    "traffic_load": "Traffic load trend",
    "time_period": "Time Period",
    "title": "Title",
    "total": "Total",
    "kpi1": {
      sort: {
        site: "Name",
        total: "Total",
      },
      value_mode: "Vrsta agregacije",
      modes: {
        ratio: "Rate",
        daily_avg: "Daily Average",
        total: "Total",
      },
      "pie_overload_share": {
        "title": "Share of overloaded vehicles",
        "no_overload": "Legal loading",
        "overload": "Overloading"
      },
      "pie_overload_types": {
        "title": "Share of overloaded types",
        "only_axle": "At least one axle overloaded",
        "only_mass": "GVW overloaded",
        "both": "GVW and axle overloaded"
      },
      tabs: {
        PKI1: "Loading and overloading 1",
        PKI2: "Loading and overloading 2",
        PKI3: "Location map",
        card: {
          "PKI1.pie": ""
        }
      },
      "pie": {
        "overload_share": {
          "title": "Share of overloaded vehicles",
          "no_overload": "Legal loading",
          "overload": "Overloading"
        },
        "overload_types": {
          "title": "Share of overloaded types",
          "only_axle": "At least one axle overloaded",
          "only_mass": "GVW overloaded",
          "both": "GVW and axle overloaded"
        },
      },
      bar: {
        total: {
          card_title: "Measurements",
          "kpi1a": {
            "title": "Number of vehicles per site",
            "yAxis": "Number of vehicles",
            "xAxis": "Measurement site"
          },
          grouping: {
            groups: "Group by",
            site: {
              option: "Measurement site",
              title: "Number of vehicles per measurement site",
              yAxis: "Number of vehicles",
              xAxis: "Measurement site",
              sort_by: {
                name: "Label",
                total: "Total",
              },
            },
            site_direction: {
              option: "Measurement site direction",
              title: "Number of vehicles per measurement site direction",
              yAxis: "Number of vehicles",
              xAxis: "Measurement site direction",
              sort_by: {
                name: "Label",
                total: "Total",
              },
            },
            direction: {
              option: "Measurement direction",
              title: "Number of vehicles per measurement direction",
              yAxis: "Number of vehicles",
              xAxis: "Measurement site",
              sort_by: {
                name: "Label",
                total: "Total",
              },
            }
          },
        },
        average: {
          card_title: "Overloading share",
          "kpi1a": {
            "title": "Number of vehicles per site",
            "yAxis": "Number of vehicles",
            "xAxis": "Measurement site"
          },
        },

        grouping: {
          groups: "Group by",
          site: {
            option: "Measurement site",
            title: "Overloading by measurement site",
            subtitle: "Types of overloading",
            xAxis: "Measurement site",
            series: {
              "legally_loaded": "Legal loading",
              "only_axle": "At least one axle overloaded",
              "only_mass": "GVW overloaded",
              "both": "GVW and axle overloaded"
            },
          },
          site_direction: {
            option: "Measurement site",
            title: "Overloading by measurement site",
            yAxis: "",
            xAxis: "Measurement site direction",
            series: {
              "legally_loaded": "Legal loading",
              "only_axle": "At least one axle overloaded",
              "only_mass": "GVW overloaded",
              "both": "GVW and axle overloaded"
            },
            sort_by: {
              legally_loaded: "Legal loading",
              only_axle: "At least one axle overloaded",
              only_mass: "GVW overloaded",
              both: "GVW and axle overloaded"
            },
          },
          direction: {
            option: "Direction",
            title: "Number of vehicles per measurement site direction",
            yAxis: "Number of vehicles",
            xAxis: "Measurement site",
            series: {
              "legally_loaded": "Legal loading",
              "only_axle": "At least one axle overloaded",
              "only_mass": "GVW overloaded",
              "both": "GVW and axle overloaded"
            },
            sort_by: {
              name: "Label",
              total: "Total",
              legally_loaded: "Legal loading",
              overloaded: "Overloaded",
              only_axle: "At least one axle overloaded",
              only_mass: "GVW overloaded",
              both: "GVW and axle overloaded"
            },
          }
        },
      },

      share: {
        card_title: "Overloading share",
        "kpi1a": {
          "title": "Number of vehicles per site",
          "yAxis": "Number of vehicles",
          "xAxis": "Measurement site"
        },
      },
      overloadCharts: {
        charts: {
          grouping: {
            label: "Group by",
            site: "Measurement site",
            site_direction: "Measurement site direction",
            direction: "Direction"
          },
          series: {
            legally_loaded: "Legal loading",
            only_axle: "At least one axle overloaded",
            only_mass: "GVW overloaded",
            both: "GVW and axle overloaded",
            overload: "Overloading",
            no_overload: "Legal loading"
          },
          bar: {
            total: {
              card_title: "Measurements total",
              site: {
                title: "Number of vehicles per site",
                xAxis: "Measurement site",
                yAxis: "Number of vehicles"
              },
              site_direction: {
                title: "Number of vehicles per site direction",
                xAxis: "Measurement site direction",
                yAxis: "Number of vehicles"
              },
              direction: {
                title: "Number of vehicles per direction",
                xAxis: "Direction",
                yAxis: "Number of vehicles"
              }
            },
            average: {
              card_title: "Average daily overloads",
              site: {
                title: "Overloading by site",
                subtitle: "Types of overloading",
                xAxis: "Measurement site"
              },
              site_direction: {
                title: "Overloading by site direction",
                subtitle: "Types of overloading",
                xAxis: "Measurement site direction"
              },
              direction: {
                title: "Overloading by direction",
                subtitle: "Types of overloading",
                xAxis: "Direction"
              }
            },
            share: {
              card_title: "Overloading share",
              site: {
                title: "Overloading share by site",
                subtitle: "Proportion of overload types",
                xAxis: "Measurement site"
              },
              site_direction: {
                title: "Overloading share by site direction",
                subtitle: "Proportion of overload types",
                xAxis: "Measurement site direction"
              },
              direction: {
                title: "Overloading share by direction",
                subtitle: "Proportion of overload types",
                xAxis: "Direction"
              }
            }
          },
          pie: {
            overload_share: {
              title: "Share of overloaded vehicles",
              series: {
                no_overload: "Legal loading",
                overload: "Overloading"
              }
            },
            overload_types: {
              title: "Share of overload types",
              series: {
                only_axle: "At least one axle overloaded",
                only_mass: "GVW overloaded",
                both: "GVW and axle overloaded"
              }
            }
          },
          line: {
            daily_overloads: {
              card_title: "Overload trends over time",
              site: {
                title: "Overload trend by site",
                xAxis: "Date"
              },
              site_direction: {
                title: "Overload trend by site direction",
                xAxis: "Date"
              },
              direction: {
                title: "Overload trend by direction",
                xAxis: "Date"
              }
            }
          },
          sort_by: {
            name: "Label",
            total: "Total",
            legally_loaded: "Legal loading",
            only_axle: "At least one axle overloaded",
            only_mass: "GVW overloaded",
            both: "GVW and axle overloaded",
            overloaded: "Overloaded"
          }
        }
      },

      "bar_overload_by_site": {
        "title": "Overloading by measurement site",
        "yAxis": "Number of vehicles",
        "xAxis": "Site",
        "series": {
          "legally_loaded": "Legal loading",
           "legally_loaded_rate": "Legal loading rate",
          "only_axle": "At least one axle overloaded",
          "only_mass": "GVW overloaded",
          "both": "GVW and axle overloaded"
        },
        "tooltip_suffix": "{count} vehicles"
      },
      "bar_overload_by_direction": {
        "title": "Overloading by measurement direction",
        "yAxis": "Number of vehicles",
        "xAxis": "Direction",
        "series": {
          "legally_loaded": "Legal loading",
          "legally_loaded_rate": "Legal loading rate",
          "only_axle": "At least one axle overloaded",
          "only_mass": "GVW overloaded",
          "both": "GVW and axle overloaded"
        },
        "tooltip_suffix": "{count} vehicles"
      },
      "bar_overload_by_site_direction": {
        "title": "Overloading by measurement site direction",
        "yAxis": "Number of vehicles",
        "xAxis": "Site - Direction",
        "series": {
          "legally_loaded": "Legal loading",
          "legally_loaded_rate": "Legal loading rate",
          "only_axle": "At least one axle overloaded",
          "only_mass": "GVW overloaded",
          "both": "GVW and axle overloaded"
        },
        "tooltip_suffix": "{count} vehicles"
      },
      "bar_totals_by_site": {
        "title": "Number of vehicles per site",
        "yAxis": "Number of vehicles",
        "xAxis": "Site",
        "series": {
          "legally_loaded": "Legal loading",
          "legally_loaded_rate": "Legal loading rate",
          "only_axle": "At least one axle overloaded",
          "only_mass": "GVW overloaded",
          "both": "GVW and axle overloaded"
        },
        "tooltip_suffix": "{count} vehicles"
      },
      "bar_totals_by_direction": {
        "title": "Number of vehicles per direction",
        "yAxis": "Number of vehicles",
        "xAxis": "Direction",
        "series": {
          "legally_loaded": "Legal loading",
          "legally_loaded_rate": "Legal loading rate",
          "only_axle": "At least one axle overloaded",
          "only_mass": "GVW overloaded",
          "both": "GVW and axle overloaded"
        },
        "tooltip_suffix": "{count} vehicles"
      },
      "bar_totals_by_site_direction": {
        "title": "Number of vehicles per site direction",
        "yAxis": "Number of vehicles",
        "xAxis": "Site | Direction",
        "series": {
          "legally_loaded": "Legal loading",
          "legally_loaded_rate": "Legal loading rate",
          "only_axle": "At least one axle overloaded",
          "only_mass": "GVW overloaded",
          "both": "GVW and axle overloaded"
        },
        "tooltip_suffix": "{count} vehicles"
      },
    },

    "kpi1a": {
      "title": "Number of vehicles per site",
      "yAxis": "Number of vehicles",
      "xAxis": "Measurement site"
    },

    "kpi2": {
      "bar_by_direction": {
        "title": "Overload Type by Direction",
        "yAxis": "Number of Vehicles",
        "yAxis_tick_suffix": " thousand",
        "series": {
          "not_overloaded": "Not Overloaded",
          "only_mass": "Total Mass Exceeded",
          "only_axle": "Axle Load Exceeded",
          "both": "Total Mass and Axle Exceeded"
        }
      },
      "line_overload_trends": {
        "title": "Legaly loaded and overloaded vehicles by type ",
        "subtitle": "",
        "yAxis": "Number of Vehicles",
        "series": {
          "total": "Total",
          "overloaded": "Overloaded",
          "only_axle": "Axle loads only",
          "only_mass": "GVW overloaded",
          "both": "Overloaded GVW and Axle loads"
        }
      }
    },
    "line_overload_trends": {
      "title": "Legaly loaded and overloaded vehicles by type ",
      "subtitle": "",
      "yAxis": "Number of Vehicles",
      "series": {
        "total": "Total",
        "overloaded": "Overloaded",
        "only_axle": "Axle loads only",
        "only_mass": "GVW overloaded",
        "both": "Overloaded GVW and Axle loads"
      }
    },
    "kpi3": {
      "map_title": "Map",
      "site": "Measurement Site",
      "measurement_count": "Number of Measurements",
      "period": "Period",
      "period_range": "From {{from}} to {{to}}",
      "unlocated_sites": "Measurement sites without defined coordinates",
      "vehicle_count": "Number of Vehicles",
      "no_coordinates": "Coordinates not available"
    },

    "actions": {
      "add_site_to_graph": "Add measurement site to chart",
      "remove_site_from_graph": "Remove measurement site from chart"
    },

    "axis": {
      "vehicle_count": "Number of Vehicles",
      "percentage": "Percentage",
      "measurement_count": "Number of Measurements"
    }
  },
  remove_filters: "Remove filters",
  my_profile: "My profile",
  logout: "Log Out",
  account_error: "There seems to be an issue with your account.",
  please_contact_admin: "Please contact an administrator.",
  cancel: "Cancel",
  save: "Save",
  create_new: "Create",
  submit: "Submit",
  delete: "Delete",
  add: "Add",
  edit: "Edit",
  stayLabel: "Stay on page",
  leaveLabel: "Leave page",
  leave_page_title: "Confirm that you want to leave.",
  leave_page_question: "You have unsaved changes. Are you sure you want to navigate away?",

  "dataset.reDraft": "UnPublish",
  "title.filter": "Filter",
  "data.filters": "Dataset - filters",
  "data.timestamp_filter": "Timestamp filters",
  "data.timestamp_range_filter": "Timestamp range filters",
  "data.string_filter": "Text filters",
  "data.numeric_filter": "Number filters",
  "dataset.reDraft_confirm": "Are you sure you want to unpublish this dataset?",
  "dialog.confirm": "Confirm",
  "dialog.no": "Cancel",
  "dialog.yes": "Yes",
  "error.validation.unique.column.label": "Labels for selection columns and aggregates must be unique.",
  "dataset.publish_confirm_unsaved_changes": "You have unsaved changes that will be lost. Are you sure you want to publish this dataset?",
  "userProfile.changePassword": "Change Password",
  "user_profile.change_password": "Change Password",
  "user_profile.profile": "Profile",
  "user_profile.user_info": "Profile information",
  "error.validation.required.filter": "Filter can not be added without a value.",
  "error.validation.required.title": "Adding filter failed.",
  "error.validation.duplicate.filter": "A filter for this column already exists. Remove it first to add a different one.",
  "error.validation.range.order": "The end value must not be before the start value.",
  "map": {
    "tooltip": {
      "period": "Period",
      "totalVehicles": "Total vehicles",
      "overloaded": "Overloaded",
      "legallyLoaded": "Legally loaded",
      "directionsCovered": "Directions",
      "directionsCount": "{{count}} direction",
      "directionsCount_plural": "{{count}} directions",
      "directionsCount_other": "{{count}} directions",
      "coordinates": "Coordinates",
      "status": {
        "included": "included",
        "partiallyExcluded": "partially excluded",
        "allExcluded": "all excluded"
      },
      "actionKey": "Ctrl/⌘",
      "hint": {
        "accelClick": "Hold {{- key }} + click to toggle all directions"
      },
      "action": {
        "accelClickToExclude": "Hold {{- key }} and click the marker to exclude this site and all directions.",
        "accelClickToInclude": "Hold {{- key }} and click the marker to include the site with all directions."
      }
    }
  },
  components: {
    // ...other components
    toggleTagGroupPanel: {
      tooltips: {
        // Included panel buttons
        selectAllIncluded: "Select all items in Included",
        selectNoneIncluded: "Clear selection in Included",
        invertSelectionIncluded: "Invert selection in Included",

        // Excluded panel buttons
        selectAllExcluded: "Select all items in Excluded",
        selectNoneExcluded: "Clear selection in Excluded",
        invertSelectionExcluded: "Invert selection in Excluded",

        // Middle controls
        moveSelectedLeft: "Include selected (move ←)",
        moveSelectedRight: "Exclude selected (move →)",
        flipSelected:
            "Swap sides for selected: Included ↔ Excluded",

        // Tag actions
        tagActionIncludeOne: "Click the arrow to include this item",
        tagActionExcludeOne: "Click the arrow to exclude this item",
      },
    },
  },
};
